window.autoPfandLoaded = true;

(function() {
  const pfandVariants = {
    '0.25': 49833691676938,
    '0.10': 49833691709706,
    '0.08': 52064558547210
  };

  let isSyncing = false;
  let pfandCache = {};

  async function getPfandDataForProduct(productHandle) {
    if (pfandCache[productHandle]) {
      return pfandCache[productHandle];
    }

    try {
      const response = await fetch(`/products/${productHandle}?view=pfand`);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const pfandScript = doc.getElementById('product-pfand-data');
      
      if (pfandScript) {
        const pfandData = JSON.parse(pfandScript.textContent);
        pfandCache[productHandle] = pfandData;
        return pfandData;
      }
      
      pfandCache[productHandle] = null;
      return null;

    } catch (error) {
      console.error('Pfand-System Fehler beim Laden von ' + productHandle + ':', error);
      pfandCache[productHandle] = null;
      return null;
    }
  }

  function getPfandForVariant(pfandData, variantId) {
    if (!pfandData) return { art: '', menge: 0 };

    if (pfandData.variants && pfandData.variants[variantId]) {
      const variant = pfandData.variants[variantId];
      return {
        art: (variant.pfandart || '').trim(),
        menge: parseInt(variant.pfandmenge || 0, 10)
      };
    }

    return {
      art: (pfandData.pfandart || '').trim(),
      menge: parseInt(pfandData.pfandmenge || 0, 10)
    };
  }

  async function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('theme:cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      try {
        if (typeof cartDrawer.renderContents === 'function') {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          cartDrawer.renderContents(cart);
        }
      } catch (e) {
        // Silent fail
      }
    }
  }

  async function syncPfand() {
    if (isSyncing) return;

    isSyncing = true;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const pfandIds = Object.values(pfandVariants);
      const productItems = cart.items.filter(item => !pfandIds.includes(item.variant_id));

      if (productItems.length === 0) {
        const updates = {};
        let hasPfand = false;
        
        Object.values(pfandVariants).forEach(pfandId => {
          const pfandItem = cart.items.find(i => i.variant_id === pfandId);
          if (pfandItem && pfandItem.quantity > 0) {
            updates[pfandId] = 0;
            hasPfand = true;
          }
        });
        
        if (hasPfand) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          await refreshCartUI();
        }
        
        isSyncing = false;
        return;
      }

      let totalPfandByType = {};

      for (const item of productItems) {
        const pfandData = await getPfandDataForProduct(item.handle);
        const { art, menge } = getPfandForVariant(pfandData, item.variant_id);

        if (art && menge && pfandVariants[art]) {
          const neededPfand = item.quantity * menge;
          totalPfandByType[art] = (totalPfandByType[art] || 0) + neededPfand;
        }
      }

      const updates = {};
      let needsUpdate = false;

      Object.keys(pfandVariants).forEach(art => {
        const pfandId = pfandVariants[art];
        const currentPfandItem = cart.items.find(i => i.variant_id === pfandId);
        const currentQty = currentPfandItem ? currentPfandItem.quantity : 0;
        const targetQty = totalPfandByType[art] || 0;

        if (currentQty !== targetQty) {
          updates[pfandId] = targetQty;
          needsUpdate = true;
        }
      });

      if (needsUpdate) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        await refreshCartUI();
      }

    } catch (error) {
      console.error('Pfand-System Fehler:', error);
    } finally {
      isSyncing = false;
    }
  }

  setTimeout(syncPfand, 500);
  setInterval(syncPfand, 5000);
  
  document.addEventListener('theme:cart:added', () => setTimeout(syncPfand, 300));
  document.addEventListener('theme:cart:change', () => setTimeout(syncPfand, 300));
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addEventListener('theme:cart:added', () => setTimeout(syncPfand, 300));
    cartDrawer.addEventListener('theme:cart:change', () => setTimeout(syncPfand, 300));
  }
})();